import React, { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import RouteLandingPage from '@/components/seo/RouteLandingPage';
import { supabase } from '@/lib/supabaseClient';
import { normalizeRoutePage } from '@/lib/normalizeRoutePage';

const RoutePage = () => {
  const { slug } = useParams();
  const [route, setRoute] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      setLoading(true);
      setNotFound(false);

      const { data, error } = await supabase
        .from('route_pages')
        .select('*')
        .eq('slug', slug)
        .eq('is_active', true)
        .single();

      if (cancelled) return;

      if (error || !data) {
        setRoute(null);
        setNotFound(true);
      } else {
        setRoute(normalizeRoutePage(data));
      }
      setLoading(false);
    })();

    return () => {
      cancelled = true;
    };
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-atithi-bg font-body text-gray-500">
        Loading route…
      </div>
    );
  }

  if (notFound || !route) {
    return <Navigate to="/" replace />;
  }

  return <RouteLandingPage route={route} />;
};

export default RoutePage;
